<script lang="ts">
    import { onMount } from 'svelte';
    import { localStorageService } from '$lib/services';

    import cs from '@components/common/common.module.css';
    import { GoogleButton } from '@components/layout/auth';
    import { globalStore } from '@components/stores';
    import { storyFeedStore } from '@components/story/feed';
    import { Countdown } from '@components/ui/countdown';
    import { Dialog, dialogStore } from '@components/ui/dialog';
    import { LL } from '@i18n/i18n-svelte';
    import { URLS } from '@shared/routing';
    import { SignupContext, type SignupContextDetails, type UserGender } from '@shared/types';
    import { Font, FontTypes } from '@uikit/font';
    import { Link } from '@uikit/link';

    import { FormBottom } from '../components/form-bottom';

    import { Description } from './components/description';
    import { Form } from './components/form';

    import s from './signup.module.css';

    import { goto } from '$app/navigation';

    export let place: SignupContext = SignupContext.Main;
    export let placeDetails: SignupContextDetails = {};
    export let gender: UserGender | undefined = undefined;
    export let isPage = false;
    export let dialogClasses = '';
    export let descClasses = '';
    export let isMinified = false;
    export let title: string | undefined = undefined;
    export let countdownEndDate: number | undefined = undefined;
    export let onCountdownFinished: (() => void) | undefined = undefined;

    function showLogin() {
        if (isPage) {
            goto(URLS.login());
        } else {
            dialogStore.showLogin($dialogStore?.closeHandler);
        }
    }

    function getEventCustomParams() {
        return {
            stories_count: Object.keys($storyFeedStore.watchedStories).length,
        };
    }

    onMount(() => {
        // on signup from story gender is not defined
        // save storyId to send it when choosing gender after signup
        if (placeDetails.storyId) {
            localStorageService.setItem('signupStoryId', placeDetails.storyId as string);
        } else {
            localStorageService.removeItem('signupStoryId');
        }
    });
</script>

{#if !isMinified}
    <Description {gender} classes={descClasses} {title} />
{/if}

<Dialog classes={dialogClasses}>
    {#if isMinified && (title || countdownEndDate)}
        <div class={cs.header}>
            {#if title}
                <Font
                    className={s.title}
                    type={FontTypes.Type.h3}
                    tagName={$globalStore.isDesktopSite ? FontTypes.TagName.h3 : FontTypes.TagName.h4}
                    color={FontTypes.Color.Primary}
                    isBold={true}
                >
                    {@html title}
                </Font>
            {/if}
            {#if countdownEndDate}
                <Countdown finishMs={countdownEndDate} onDone={onCountdownFinished} />
            {/if}
        </div>
    {/if}
    <GoogleButton signup {gender} />
    <div class={cs.divider}></div>
    <Form {gender} {place} {getEventCustomParams} />
    <FormBottom
        headerText={$LL.auth.alreadyMember()}
        linkText={$LL.auth.signin()}
        onClick={showLogin}
    >
        <Font
            className={s.terms}
            type={FontTypes.Type.tiny}
            tagName={FontTypes.TagName.p}
            color={FontTypes.Color.Secondary}
        >
            {@html $LL.auth.terms({
                termsOfUseLink: URLS.termsOfUse(),
                privacyLink: URLS.privacyPolicy(),
            })}
        </Font>
    </FormBottom>
</Dialog>

{#if !isMinified}
    <Font className={s.belowText} tagName={FontTypes.TagName.div} type={FontTypes.Type.body}>
        {$LL.auth.report.text()}
        <Link isUnderline href={URLS.reportContent()} on:click={() => {
            dialogStore.closeDialog();
        }}>
            {$LL.auth.report.link()}
        </Link>
    </Font>
{/if}
